export interface IStayPriceRow {
    title: string;
    type?: EStayRowType;
    total: IStayPriceRowPrice;
    traveller: IStayPriceRowTravellerPrice[];
    collapser?: string;
    collapseGroup?: string;
    isHeaderRow?: boolean;
}

export interface IStayPriceRowTravellerPrice extends IStayPriceRowPrice{
    id: string;
}

export interface IStayPriceRowPrice {
    amount: number;
    currency: string;
}

export enum EStayRowType {
    fee = 'fee',
    total = 'total',
    base = 'base',
}
